import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginHandlerService {
 THREE_MINUTES_IN_MILLISECONDS = 3 * 60 * 1000;


  constructor() { }
}
